import { Form, useActionData, useLocation } from "react-router-dom";
import FormControl from "react-bootstrap/FormControl";

import { LoginWithGoogleButton } from "../../components/LoginWithGoogleButton";
import { TurnstileWidget } from "../../components/TurnstileWidget";
import { useTitle } from "../../hooks/useTitle";
import { wwwUrl } from "../../config/environment";

import "../auth/auth.css";

export function RegisterPage() {
    useTitle("Start a free ledger");
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const from = params.get("from") || "/";
    const actionData = useActionData();

    return (
        <section className="mkt-auth">
            <div className="mkt-auth-mast">
                <div className="mkt-auth-mast-kicker">New account</div>
                <h1>
                    Open the book on your <em>Friday Night.</em>
                </h1>
                <p>
                    Free for 2 games a month. No card needed. Five minutes once,
                    never again.
                </p>
            </div>

            <div className="mkt-auth-card">
                <Form method="post" replace className="mkt-auth-form">
                    <FormControl hidden={true} name="redirectTo" value={from} />
                    <div className="mkt-auth-row">
                        <div>
                            <label className="mkt-auth-label" htmlFor="signup-first">First name</label>
                            <FormControl
                                id="signup-first"
                                required
                                name="firstName"
                                type="text"
                                placeholder="Avery"
                            />
                        </div>
                        <div>
                            <label className="mkt-auth-label" htmlFor="signup-last">Last name</label>
                            <FormControl
                                id="signup-last"
                                required
                                name="lastName"
                                type="text"
                                placeholder="Hartwell"
                            />
                        </div>
                    </div>
                    <div>
                        <label className="mkt-auth-label" htmlFor="signup-email">Email</label>
                        <FormControl
                            id="signup-email"
                            required
                            name="email"
                            type="email"
                            placeholder="you@example.com"
                        />
                    </div>
                    <div>
                        <label className="mkt-auth-label" htmlFor="signup-password">Password</label>
                        <FormControl
                            id="signup-password"
                            required
                            name="password"
                            type="password"
                            placeholder="at least 8 characters"
                        />
                    </div>
                    <div>
                        <label className="mkt-auth-label" htmlFor="signup-club">Club name</label>
                        <FormControl
                            id="signup-club"
                            required
                            name="description"
                            placeholder="Friday Night Cash"
                        />
                    </div>
                    <label className="mkt-auth-terms">
                        <input
                            type="checkbox"
                            id="acceptedTerms"
                            name="acceptedTerms"
                            required
                        />
                        <span>
                            I agree to the{" "}
                            <a href={wwwUrl("/terms")} target="_blank" rel="noopener noreferrer">
                                Terms of Service
                            </a>{" "}
                            and{" "}
                            <a href={wwwUrl("/privacy")} target="_blank" rel="noopener noreferrer">
                                Privacy Policy
                            </a>.
                        </span>
                    </label>
                    <TurnstileWidget />
                    <button type="submit">Open my book</button>
                    <div className="mkt-auth-divider">or</div>
                    <LoginWithGoogleButton className="mkt-auth-google" />
                    {actionData && actionData.error && (
                        <div className="mkt-auth-error">{actionData.error}</div>
                    )}
                </Form>
                <div className="mkt-auth-foot">
                    Already have an account? <a href="/login">Sign in</a>
                </div>
            </div>
        </section>
    );
}
